import { Flex, Typography } from "antd"
import classname from "classname"

import Icon from "../../../../../Icon"

import "./InfoLine.less"

const { Text } = Typography

const InfoLine = ({ text, variant = "neutral", style }) => {
  return (
    <Flex className="infoLine" gap={8} style={style}>
      <Icon type="info_bubble" className={classname("icon", variant)} />
      <Text
        type="secondary"
        strong
        style={{ lineHeight: "16px", fontSize: "12px", letterSpacing: 0 }}
      >
        {text}
      </Text>
    </Flex>
  )
}

export default InfoLine
